import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  data: any = {};
  constructor(public router: Router, public appservice: AppService) {

    this.data = appservice.Current_User;


  }
  addReset() {
    this.appservice.isadd = "0";
    return this.router.navigate(['/settings/change-password']);
  }

  addHome(){
    this.router.navigate(['transaction/daily-log-sheet']);
  }

 get supportTicketUrl(): string {
    const base = 'http://support.qubha.com//ticket-entry';
    const userName = encodeURIComponent(String(this.appservice.Emp_Name || '').trim());
    const userEmail = encodeURIComponent(String(this.appservice.Emp_Email || '').trim());
    return `${base}?project_Code=PR00144&customer_Code=C0124&user_Name=${userName}&user_EMail=${userEmail}`;
  }

openSupportTicket(): void {
  window.open(this.supportTicketUrl, '_blank');
}

  lenth: number = 0;

  logout() {
    this.appservice.logout();
  }
  onPlayButtonShow() {
    this.appservice.isPlayToggleShow = !this.appservice.isPlayToggleShow;
  }
  ngOnInit() {
  }


}
